import { useMediaQuery } from "react-responsive";

export const useMedia = () => {
  const isSmall = useMediaQuery({ query: "(min-width: 600px)" });
  const isMedium = useMediaQuery({ query: "(min-width: 768px)" });
  const isDesktop = useMediaQuery({ query: "(min-width: 1030px)" });

  if (isDesktop) return "desktop";
  if (isMedium) return "medium";
  if (isSmall) return "small";
  return "very-small";
};
